module.exports = __webpack_public_path__ + "img/new_login.b9b50923.png";